import React, { useEffect } from 'react';
import Section from '../components/Section';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <main className="pt-20 bg-white">
        <Section>
          <div className="max-w-3xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-zinc-950 mb-4">
              Terms & Conditions
            </h1>
            <p className="text-zinc-500 mb-12 italic">Last Updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>

            <div className="prose prose-zinc max-w-none space-y-12 text-zinc-600">
              <section>
                <h2 className="text-2xl font-bold text-zinc-900 mb-4">1. Overview</h2>
                <p className="leading-relaxed">
                  By purchasing or using a Data Risk Audit report, you agree to be bound by these Terms & Conditions. Our service provides expert informational insights and analysis based on current digital privacy landscapes and public data practices.
                </p>
              </section>

              <section className="bg-zinc-50 p-8 rounded-2xl border border-zinc-200">
                <h2 className="text-2xl font-bold text-zinc-900 mb-4">2. Nature of Service</h2>
                <p className="text-zinc-900 font-medium mb-4 leading-relaxed">
                  The Data Risk Audit is provided for informational and educational purposes only.
                </p>
                <ul className="list-disc pl-6 space-y-3 text-zinc-700">
                  <li>The audit is based on publicly available information, privacy policies, and general technical analysis of known app behaviors.</li>
                  <li>We do not guarantee 100% accuracy or completeness, as application practices can change without notice.</li>
                  <li><strong>This report does NOT constitute legal, financial, or professional security advice.</strong></li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-zinc-900 mb-4">3. User Responsibility</h2>
                <p className="leading-relaxed">
                  You are solely responsible for how you choose to act upon the recommendations provided in the audit. Data Risk Audit is not responsible for any decisions made, or actions taken, based on the content of the report. You should consult with relevant professionals before making significant security or legal changes.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-zinc-900 mb-4">4. Payments & Refunds</h2>
                <p className="leading-relaxed mb-4">
                  The service requires a one-time payment as specified at the time of purchase. Pricing is subject to change.
                </p>
                <div className="bg-white border border-zinc-200 p-5 rounded-xl">
                  <p className="text-zinc-900 font-bold mb-1">Refund Policy:</p>
                  <p className="text-zinc-600">No refunds will be issued once the final audit report has been delivered to your email. If you wish to cancel before work has begun, please contact us immediately.</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-zinc-900 mb-4">5. Delivery</h2>
                <p className="leading-relaxed">
                  We aim to deliver all reports within 24–48 hours of receiving your app list. While we strive for punctuality, delivery times are estimates and may be affected by volume or complexity.
                </p>
              </section>

              <section className="border-l-4 border-zinc-950 pl-8 py-2">
                <h2 className="text-2xl font-bold text-zinc-900 mb-4 uppercase tracking-tight">6. Limitation of Liability</h2>
                <p className="text-zinc-900 font-bold leading-relaxed">
                  To the maximum extent permitted by law, Data Risk Audit and its operators shall not be liable for any damages, losses, or consequences (direct or indirect) resulting from your use of the report or your reliance on its findings.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-zinc-900 mb-4">7. Intellectual Property</h2>
                <p className="leading-relaxed">
                  The audit reports are intended for your personal, non-commercial use only. You may not resell, redistribute, or publicly publish the contents of your specific report without our prior written consent.
                </p>
              </section>

              <section className="pt-8 border-t border-zinc-100">
                <h2 className="text-2xl font-bold text-zinc-900 mb-4">8. Contact</h2>
                <p className="leading-relaxed">
                  Questions regarding these terms should be directed to:<br />
                  <a href="mailto:hello@datariskaudit.com" className="font-bold text-zinc-950 hover:underline">hello@datariskaudit.com</a>
                </p>
              </section>
            </div>
          </div>
        </Section>
      </main>
      <Footer />
    </>
  );
};

export default Terms;